import React, { useState } from 'react'
import _, { isEmpty } from 'lodash'
import { Button, Col, Form, Icon, Input, Modal, Select, Row, Upload, Radio, Tooltip } from 'antd'
import { ButtonEx } from '../../../../../../styles/button.style'
import { useDeepEffect } from '../../../../../../utils/hooks'

const RadiusForm = (props) => {
  const { visible, onOk, onCancel, formData, form, heroId } = props
  const { getFieldDecorator, validateFields, setFieldsValue } = form

  useDeepEffect(() => {
    if (!isEmpty(formData)) {
      setFieldsValue({
        radius: formData.radius,
        maxLocation: formData.maxLocation
      })
    }
    return () => {
      form.resetFields()
    }
  }, [formData])


  function onSubmit(e) {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        const data = {
          heroId: heroId,
          radius: values.radius,
          maxLocation: values.maxLocation
        }
        onOk(data)
      }
    })
  }

  return (
    <Modal
      title='Edit Config by Hero'
      visible={visible}
      footer={null}
      onCancel={onCancel}>
      <Form form={form} onSubmit={onSubmit} layout="vertical">
        <Form.Item label="Radius">
          {getFieldDecorator(`radius`, {
            rules: [
              {
                required: true,
                message: 'กรุณากรอก'
              }
            ]
          })(<Input type="number"
            name="radius"
            placeholder="Radius" />)}
        </Form.Item>
        <Form.Item label="Max Location">
          {getFieldDecorator(`maxLocation`, {
            rules: [
              {
                required: true,
                message: 'กรุณากรอก'
              }
            ]
          })(<Input type="number"
            name="maxLocation"
            placeholder="Max Location" />)}
        </Form.Item>
        <Row type="flex" gutter={8} justify="end">
          <Col>
            <Button onClick={() => onCancel()}>ยกเลิก</Button>
          </Col>
          <Col>
            <ButtonEx color="#6ebf4b" type="primary" htmlType="submit">
              บันทึก
            </ButtonEx>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

const WrappedRadiusForm = Form.create({ name: 'RadiusForm' })(
  RadiusForm
)
export default WrappedRadiusForm
